import React, { useState } from 'react'
import { useIntl } from 'gatsby-plugin-react-intl'
import * as styles from './ConfidentialitySettings.module.scss'
import CgCheckbox from '../cg-checkbox/CgCheckbox'

export interface ConfidentialitySettings {
  analytics: boolean
  facebook: boolean
  advertising: boolean
}
interface CookieOptionsProps {
  onSubmit(value: ConfidentialitySettings): void
}
const CookieOptions: React.FC<CookieOptionsProps> = ({ onSubmit }) => {
  const t = useIntl()
  const [analytics, setAnalytics] = useState(true)
  const [facebook, setFacebook] = useState(false)
  const [advertising, setAdvertising] = useState(false)

  function handleSubmit (e: React.FormEvent) {
    onSubmit({ analytics, facebook, advertising })
    e.preventDefault()
  }

  const options: ({
    key: keyof ConfidentialitySettings
    get: boolean
    set(v: boolean): void
  })[] = [
    { key: 'analytics', get: analytics, set: setAnalytics },
    { key: 'facebook', get: facebook, set: setFacebook },
    { key: 'advertising', get: advertising, set: setAdvertising }
  ]

  return (
    <div className={styles.container}>
      <div>
        <div className={styles.sentence}>
          {t.formatMessage({ id: 'confidentialitySettings.sentence' })}
        </div>
        <form name='privacyForm' onSubmit={handleSubmit}>
          <div className={styles.title}>
            {t.formatMessage({ id: 'confidentialitySettings.cookies' })}
          </div>

          {options.map(({ key, get, set }) => (
            <div key={key} className={styles.checkboxContainer}>
              <div className={styles.checkbox}>
                <CgCheckbox
                  value={get}
                  onChange={set}
                  id={`cg-landing-confidentiality-settings-${key}`}
                />
              </div>
              <label
                htmlFor={`cg-landing-confidentiality-settings-${key}`}
                className={styles.checkboxLabel}
              >
                <div className={styles.checkboxLabelTitle}>
                  {t.formatMessage({ id: `confidentialitySettings.${key}` })}
                </div>
                <div className={styles.checkboxLabelDetails}>
                  {t.formatMessage({ id: `confidentialitySettings.${key}Details` })}
                </div>
              </label>
            </div>
          ))}

          <button className={styles.submitButton}>
            {t.formatMessage({ id: 'confidentialitySettings.submit' })}
          </button>
        </form>
      </div>
    </div>
  )
}

export default CookieOptions
